export const modifyEntitySettingObj = (entitySetting) => {
    if (!entitySetting?.query_parameter) return entitySetting;

    return {
        ...entitySetting,
        query_parameter: entitySetting?.query_parameter?.map((qp) => {
            if (qp.param) {
                return {
                    ...qp,
                    param: {
                        label: qp.param.label ?? "",
                        value: qp.param.value ?? "",
                    },
                };
            }
            return qp;
        }),
    };
}

export const getAllParentNodeResults = (currentNodeId: string | null, flowObj: any) => {
    const globalParams = [
        { value: "global__whatsapp_name", label: "global__whatsapp_name", paramType: "global" },
        { value: "global__whatsapp_number", label: "global__whatsapp_number", paramType: "global" },
        { value: "global__id", label: "global__id", paramType: "global_lead_data" }
    ];
    if (!currentNodeId || !flowObj) return globalParams;
    try {
        const nodes = flowObj?.nodes || [];
        const edges = flowObj?.edges || [];
        const results: any[] = [];
        const visited = new Set < string > ();
        const findParents = (nodeId: string) => {
            if (visited.has(nodeId)) return;
            visited.add(nodeId);

            const parentEdges = edges.filter(edge => edge.target === nodeId);
            parentEdges.forEach(edge => {
                const parentNode = nodes.find(node => node.id === edge.source);
                if (parentNode) {
                    // collect result if available
                    const res = parentNode?.data?.triggerSettings?.result;
                    if (res) {
                        results.push(res);
                    }
                    // recurse upwards
                    findParents(parentNode.id);
                }
            });
        };
        findParents(currentNodeId);

        // Remove duplicates based on 'value'
        const allParams = [...globalParams, ...results];
        const seen = new Set < string > ();
        const uniqueParams = allParams.filter(param => {
            if (!param?.value) return false;
            if (seen.has(param.value)) return false;
            seen.add(param.value);
            return true;
        });

        return uniqueParams;
    } catch (error) {
        console.error("Error in getAllParentNodeResults:", error);
        return globalParams;
    }
};